'use client';

import React, { useEffect, useMemo, useState } from 'react';
import EventSignupModal from '@/components/modals/EventSignupModal';
import { ALL_EVENTS } from '@/data/events';

export default function SignupModalController() {
  const [open, setOpen] = useState(false);
  const [lockEvent, setLockEvent] = useState(false);
  const [defaultEventId, setDefaultEventId] = useState<string | undefined>();

  useEffect(() => {
    const handler = (ev: Event) => {
      const detail = (ev as CustomEvent).detail || {};

      setDefaultEventId(detail.eventId);
      setLockEvent(Boolean(detail.lockEvent));
      setOpen(true);
    };

    window.addEventListener('open-signup', handler as EventListener);
    return () => window.removeEventListener('open-signup', handler as EventListener);
  }, []);

  const modalEvents = useMemo(() => {
    if (lockEvent && defaultEventId) {
      const found = ALL_EVENTS.find(e => e.id === defaultEventId);
      return found ? [found] : ALL_EVENTS;
    }
    return ALL_EVENTS;
  }, [lockEvent, defaultEventId]);

  return (
    <EventSignupModal
      open={open}
      onClose={() => setOpen(false)}
      events={modalEvents}
      defaultEventId={defaultEventId}
      lockEvent={lockEvent}
    />
  );
}
